import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPresets } from '@principle-theorem/ng-shared';
import {
  PractitionerAttributionDialogComponent,
  IPractitionerAttributionDialogRequest,
  IPractitionerAttributionDialogResponse,
} from './practitioner-attribution-dialog.component';

@Injectable({ providedIn: 'root' })
export class PractitionerAttributionDialogService {
  constructor(private _dialog: MatDialog) {}

  async open(
    data: IPractitionerAttributionDialogRequest
  ): Promise<IPractitionerAttributionDialogResponse | undefined> {
    return this._dialog
      .open<
        PractitionerAttributionDialogComponent,
        IPractitionerAttributionDialogRequest,
        IPractitionerAttributionDialogResponse
      >(PractitionerAttributionDialogComponent, DialogPresets.medium({ data }))
      .afterClosed()
      .toPromise();
  }
}
